module.exports = __webpack_public_path__ + "img/quote.e0fcb910.svg";